import 'jquery';
import moment from 'moment';

import 'bootstrap/dist/css/bootstrap.min.css';
// Self-hosted Open Sans (latin + latin-ext), weights 300 / 400 / 600 — replaces Google Fonts @import in SCSS
import '@fontsource/open-sans/latin-300.css';
import '@fontsource/open-sans/latin-400.css';
import '@fontsource/open-sans/latin-600.css';
import '@fontsource/open-sans/latin-ext-300.css';
import '@fontsource/open-sans/latin-ext-400.css';
import '@fontsource/open-sans/latin-ext-600.css';
import '../scss/styles.scss';

// ESM build does not set global.bootstrap; helpers and browse.js use window.bootstrap.
import * as bootstrap from 'bootstrap';
if (typeof window !== 'undefined') {
    window.bootstrap = bootstrap;
}

import 'owl.carousel';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';

import { initDateTimePicker, getDateTimePicker } from './core/date-picker.js';
import {
    initTooltip, initPopover, showPopover,
    showModal, hideModal
} from './core/bootstrap-helpers.js';
import { getUrlVars } from './core/utilities.js';

import { resizeStickyContent, buttonAnimation, initFeedback } from './ui/feedback.js';
import { respondNavbarForms, initNavbarForms } from './ui/navbar.js';
import { initEmailPopup, initOrderMethodPopup, initUserMessagePopup } from './ui/popups.js';
import { initOrderingModeModal } from './ui/ordering-mode.js';
import { initUniversalToggle, initToggleDependentController } from './ui/toggle.js';
import { applyViewAsToLinks } from './ui/view-as-links.js';
import { displayToastrAlert } from './ui/toastr-alert.js';
import { initLazyWidget } from './ui/lazy-widget.js';

import { resetApplicationFacets, initYMM } from './ymm/ymm-lookup.js';
import { initFitmentApplication } from './ymm/fitment.js';
import { initEngineLookup } from './ymm/engine-lookup.js';

import { initAjaxForm } from './forms/ajax-form.js';
import { initDeleteButtons } from './forms/delete-buttons.js';
import { initColorPickers } from './forms/color-pickers.js';
import { initHTMLEditors } from './forms/html-editors.js';
import { initDateRangeFilter } from './forms/date-range-filter.js';
import './forms/serialize-object.js';
import { initWidgetAdminSave } from './forms/widget-admin-save.js';

import { initClipboard } from './clipboard.js';
import { initDataTables } from './data-tables.js';

import { initOrdering } from './ordering/index.js';
import { initCheckoutWarehouseSplit } from './ordering/checkout-warehouse-split.js';
import { setInventoryConfig } from './ordering/inventory.js';
import { initAccountSearch } from './search/account-search.js';

import { callAsync, setAsUserId } from './async/call-async.js';
import { asyncPostOnload, populateAsyncInventoryDisplay, kitBuilderTableTotals, displayResponseMessage, getAltKitBuilderItems } from './async/post-onload.js';
import { initAsyncHandlers } from './async/handlers.js';

import { initReturns } from './returns.js';
import { initRebatesList } from './rebates.js';
import { initEliteExtraOrders } from './elite-extra.js';

$(document).ready(readyPage);

function readyPage() {
    var $productAvailabilityAvailable = $('#product-availability-available');
    var $productAvailabilityOutOfStock = $('#product-availability-out-of-stock');
    var $productAvailabilityUnavailable = $('#product-availability-unavailable');
    var $productAvailabilityBackorder = $('#product-availability-backorder');
    var $productAvailabilityDropship = $('#product-availability-dropship');
    var $pricingFallbackMessage = $('#pricing-fallback-message');
    var $disableOrderingOnFallback = $('#disable-ordering-fallback');
    var $stockDisplayCap = $('#stock-display-cap');

    setInventoryConfig({
        productAvailabilityAvailable: $productAvailabilityAvailable.length
            ? $productAvailabilityAvailable.val() : 'Available',
        productAvailabilityOutOfStock: $productAvailabilityOutOfStock.length
            ? $productAvailabilityOutOfStock.val() : 'Out of Stock',
        productAvailabilityUnavailable: $productAvailabilityUnavailable.length
            ? $productAvailabilityUnavailable.val() : 'Unavailable',
        productAvailabilityBackorder: $productAvailabilityBackorder.length
            ? $productAvailabilityBackorder.val() : 'Place on Backorder',
        productAvailabilityDropship: $productAvailabilityDropship.length
            ? $productAvailabilityDropship.val() : 'Manufacturer Drop-Ship',
        pricingFallbackMessage: $pricingFallbackMessage.length
            ? $pricingFallbackMessage.val() : 'Pricing Unavailable',
        disableOrderingOnFallback: $disableOrderingOnFallback.length
            && $disableOrderingOnFallback.val() == 'true',
        customOrderText: $('#order-text').val(),
        stockDisplayCap: parseInt($stockDisplayCap.val()),
    });

    buttonAnimation();
    respondNavbarForms();
    resizeStickyContent();
    initFeedback();
    initNavbarForms();
    initYMM();
    initEngineLookup();
    initFitmentApplication();
    if ($('#searchBox').length || $('.js-search-box-mobile').length) {
        import('./search/autocomplete.js').then(({ initSearchBar }) => {
            initSearchBar();
        });
    }
    initAccountSearch();
    initAjaxForm();
    initOrdering();
    initCheckoutWarehouseSplit();
    initReturns();
    initDeleteButtons();
    initClipboard();
    initColorPickers();
    initHTMLEditors();
    initDataTables();
    initRebatesList();
    initEliteExtraOrders();
    initUserMessagePopup();
    initEmailPopup();
    initUniversalToggle();
    initToggleDependentController();
    initOrderMethodPopup();
    initOrderingModeModal();
    initAsyncHandlers();

    $('[data-bs-toggle="tooltip"]').each(function () {
        initTooltip($(this));
    });

    $(window).resize(function () {
        respondNavbarForms();
        resizeStickyContent();
    });

    $(document).on('scroll', function () {
        // `#main` only exists in the storefront layout, not the admin shell
        // (layout_c.inc uses #cp-main). Guard so admin pages don't throw a
        // TypeError on every scroll tick from `.position()` being undefined.
        var $main = $('#main');
        if ($main.length) {
            if ($(this).scrollTop() >= $main.position().top) {
                $('.navbar-wrapper').addClass('scrolled');
            } else {
                $('.navbar-wrapper').removeClass('scrolled');
            }
        }
        resizeStickyContent();
    });

    setAsUserId($('#au').val());
    applyViewAsToLinks();
    asyncPostOnload();
}

// Expose functions on window for inline scripts in PHP views that still reference them.
window.moment = moment;
window.initDateTimePicker = initDateTimePicker;
window.getDateTimePicker = getDateTimePicker;
window.initTooltip = initTooltip;
window.initPopover = initPopover;
window.showPopover = showPopover;
window.showModal = showModal;
window.hideModal = hideModal;
window.getUrlVars = getUrlVars;
window.displayToastrAlert = displayToastrAlert;
window.resetApplicationFacets = resetApplicationFacets;
window.callAsync = callAsync;
window.populateAsyncInventoryDisplay = populateAsyncInventoryDisplay;
window.kitBuilderTableTotals = kitBuilderTableTotals;
window.displayResponseMessage = displayResponseMessage;
window.getAltKitBuilderItems = getAltKitBuilderItems;
window.initDateRangeFilter = initDateRangeFilter;
window.initWidgetAdminSave = initWidgetAdminSave;
window.initLazyWidget = initLazyWidget;

// Dynamic page-module router — replaces per-page <script> tags in layout.inc.
// PHP sets window.__PAGE_CTX__ with { segments, isHome, isCP } before this module loads.
(function loadPageModules() {
    var ctx = window.__PAGE_CTX__;
    if (!ctx) return;

    var segments = ctx.segments;
    var isHome = ctx.isHome;
    var isCP = ctx.isCP;
    var s = function (i) { return segments[i] || ''; };

    if (isHome || s(0) === 'catalog' || (isCP && s(1) === 'widgets')) {
        import('./partials/widgets.js');
    }

    if (s(0) === 'catalog') {
        import('./partials/catalog.js');
        import('./partials/letter-links.js');
    }

    if (s(0) === 'order' || s(0) === 'catalog' || s(0) === 'specials') {
        import('./partials/product-browse.js');

        if (
            s(1) === 'browse' ||
            s(1) === 'categories' ||
            s(1) === 'brands' ||
            (s(0) === 'catalog' && s(1) === '') ||
            s(0) === 'specials'
        ) {
            import('./partials/browse.js');
        } else if (s(1) === 'item') {
            import('./partials/product.js');
        } else if (s(1) === 'history' || s(1) === 'for_print' || s(1) === 'submit') {
            import('./partials/orders.js');
        } else if (s(1) === 'view') {
            import('./partials/checkout-inventory.js').then(function (m) {
                m.initCheckoutInventory();
            });
        }
    }

    if (isCP) {
        // Admin shell (off-canvas sidebar, tooltips) — loads on every CP page
        import('./partials/control_panel/admin-shell.js').then(function (m) {
            m.initAdminShell();
        });

        if (s(1) === 'reports') {
            import('./partials/control_panel/reports.js');
            var reportLoaders = {
                accounts:   function () { return import('./partials/control_panel/reports-accounts.js'); },
                brands:     function () { return import('./partials/control_panel/reports-brands.js'); },
                categories: function () { return import('./partials/control_panel/reports-categories.js'); },
                items:      function () { return import('./partials/control_panel/reports-items.js'); },
                pages:      function () { return import('./partials/control_panel/reports-pages.js'); },
            };
            var loader = reportLoaders[s(2)];
            if (loader) loader();
        }

        if (s(1) === 'order_settings') {
            import('./partials/control_panel/order-settings.js');
        }

        if (s(1) === 'ymm') {
            import('./partials/control_panel/ymm.js');
        }

        if (s(1) === 'brands') {
            import('./partials/control_panel/brands.js');
        }

        if (s(1) === 'widgets') {
            import('./partials/control_panel/widgets.js');
        }

        if (s(1) === 'users') {
            import('./partials/control_panel/users.js');
        }

        if (s(1) === 'design' || s(1) === 'widgets') {
            import('./partials/control_panel/design.js');
        }

        if (s(1) === 'pages') {
            import('./partials/control_panel/custom-page.js');
        }
    }
})();
